"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const mutation = (0, client_1.gql) `
  mutation updateVenue($venue: VenueInput!) {
    updateVenue(venue: $venue) {
      _id
      orgId
      name
      description
      capacity
      address {
        address1
        address2
        city
        state
        zip
        country
        phone
        lat
        lng
        placeId
        placeName
      }
      url
      tax
      imageUrls
      venueGlobalId
    }
  }
`;
exports.default = mutation;
//# sourceMappingURL=updateVenue.mutation.js.map